import { render, staticRenderFns } from "./UNClassForm.vue?vue&type=template&id=20393434"
import script from "./UNClassForm.vue?vue&type=script&lang=js"
export * from "./UNClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports